import { MainPage } from "../page/main";

function App() {
  return (
    <MainPage/>
  );
}

export default App;
